export function Notifications() {
  return (
    <center>
      <div className="parent">
        <div className="flex justify-center">
          <img
            className="w-60"
            src="https://in.indeed.com/notifications/static/images/NotificationBell-6babc1.png"
            alt=""
          />
        </div>
        <div className="text-center">
            <h3>Nothing right now. Check back later!</h3>
            <p className="text-black mx-5 mt-3">This is where we’ll notify you about your job applications and other useful information to help you with your job search.</p>
            <button className="a-button text-white w-72">Find Jobs</button>
        </div>
      </div>
    </center>
  );
}
